const defaultBooleanOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export default defaultBooleanOptions;